import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatMenuModule } from '@angular/material/menu';
import { AumicoCoreModule } from '@modeso/aumico-lib-core-fe';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18NextModule } from 'angular-i18next';
import { AumicoComponentsModule } from '../../../aumico-components/src/lib';
import { AumicoCompaniesConfig, AumicoCompaniesConfigService } from './aumico-companies.config';
import { BulkCreateFinancialYearModalComponent } from './components/bulk-create-financial-year-modal/bulk-create-financial-year-modal.component';
import { CompanyDataFormComponent } from './components/companies-data-form/company-data-form.component';
import { ZefixSearchComponent } from './components/zefix-search/zefix-search.component';
import { TagBoxComponent } from './components/tag-box/tag-box.component';
import { PersonFormComponent } from './components/person-form/person-form.component';
import { PersonsOverviewComponent } from './components/persons-overview/persons-overview.component';
import { UploadModalComponent } from './components/companies-data-form/upload-modal/upload-modal.component';
import { CompanyMetaInfoComponent } from './components/company-meta-info/company-meta-info.component';
import { LicenceBannerComponent } from './components/licence-banner/licence-banner.component';
import { IntegrationCardComingSoonComponent } from './components/integration-card-coming-soon/integration-card-coming-soon.component';
import { BexioEffects } from './effects/bexio.effects';
import { CompaniesEffects } from './effects/companies.effects';
import { PersonsEffects } from './effects/persons.effects';
import { TagsEffects } from './effects/tags.effects';
import { CompaniesListComponent } from './pages/companies-list/companies-list.component';
import { CompaniesList2Component } from './pages/companies-list/companies-list2.component';
import { EditCompanyComponent } from './pages/edit-company/edit-company.component';
import * as fromReducer from './reducer/companies.reducer';
import { BEXIO_FEATURE_KEY, bexioReducer } from './reducer/bexio.reducer';
import { personsFeatureKey, personsReducerFn } from './reducer/persons.reducer';
import { tagsFeatureKey, tagsReducerFn } from './reducer/tags.reducer';
import { COMPANIES_UI_FEATURE, uiReducer } from './reducer/ui.reducer';
import { AumicoCompaniesService } from './services/companies.service';
import { BexioService } from './services/bexio.service';
import { AumicoPersonsService } from './services/persons.service';
import { AumicoTagsService } from './services/tags.service';
import { ZefixService } from './services/zefix.service';

const EXPORTED_DECLARATIONS = [
    CompanyDataFormComponent,
    CompaniesListComponent,
    CompaniesList2Component,
    EditCompanyComponent,
    UploadModalComponent,
    LicenceBannerComponent,
    BulkCreateFinancialYearModalComponent,
    IntegrationCardComingSoonComponent,
    ZefixSearchComponent,
    TagBoxComponent,
    PersonFormComponent,
    PersonsOverviewComponent,
];
const ANGULAR_MATERIAL = [MatGridListModule, MatMenuModule];

@NgModule({
    declarations: [EXPORTED_DECLARATIONS, CompanyMetaInfoComponent],
    providers: [],
    imports: [
        AumicoCoreModule,
        AumicoComponentsModule,
        CommonModule,
        I18NextModule,
        FormsModule,
        ReactiveFormsModule,
        StoreModule.forFeature(fromReducer.companiesFeatureKey, fromReducer.reducer),
        StoreModule.forFeature(COMPANIES_UI_FEATURE, uiReducer),
        StoreModule.forFeature(BEXIO_FEATURE_KEY, bexioReducer),
        // REV-22155: persons + tags
        StoreModule.forFeature(personsFeatureKey, personsReducerFn),
        StoreModule.forFeature(tagsFeatureKey, tagsReducerFn),
        EffectsModule.forFeature([CompaniesEffects, BexioEffects, PersonsEffects, TagsEffects]),
        ANGULAR_MATERIAL,
    ],
    exports: [EXPORTED_DECLARATIONS],
})
export class AumicoCompaniesModule {
    static forRoot(config: AumicoCompaniesConfig): ModuleWithProviders<AumicoCompaniesModule> {
        return {
            ngModule: AumicoCompaniesModule,
            providers: [
                AumicoCompaniesService,
                AumicoPersonsService,
                AumicoTagsService,
                BexioService,
                ZefixService,
                {
                    provide: AumicoCompaniesConfigService,
                    useValue: config,
                },
            ],
        };
    }
}
